import { useDateLocale, useTimeZone } from '../../../../hooks'
import { formatDate } from '../../../Table'
import Text from '../../../Text'

import { EMAIL_PROFILE_RAW_MESSAGE_DATE_FORMAT } from './EmailProfileRawMessage.constants'
import { prepareRawMessageHtml } from './EmailProfileRawMessage.utils'
import { Participants } from './Participants'

import * as styles from './EmailProfileRawMessage.module.css'

function EmailProfileRawMessage({
  bcc,
  cc,
  created,
  rawText,
  sender,
  text,
  to,
}) {
  const timezone = useTimeZone()
  const locale = useDateLocale()

  const preparedMessage = prepareRawMessageHtml({ rawText, text })

  return (
    <>
      <div className={styles.header}>
        <Participants bcc={bcc} cc={cc} sender={sender} to={to} />
        <Text className={styles.text}>
          {formatDate({
            date: created,
            dateFormat: EMAIL_PROFILE_RAW_MESSAGE_DATE_FORMAT,
            locale,
            timezone,
            useTodayFormat: false,
          })}
        </Text>
      </div>
      <div
        className={styles.message}
        dangerouslySetInnerHTML={{ __html: preparedMessage }}
      />
    </>
  )
}

export default EmailProfileRawMessage
